<div class="approvals-results-main"
    infiniteScroll
    [infiniteScrollDistance]="0.01"
    [infiniteScrollThrottle]="250"
    (scrolled)="onScroll()"
>
    <ul class="results" *ngIf="displayedItems !=null">
        <li class="result-item" *ngFor="let version of displayedItems" >
            <versions-summary-status-box
                [version]="version"
                [exclude]="excludedLabels"
                [feedbacks]="getFeedbacks(version)"
                [menu]="menu"
                (menuClick)="onMenuClick($event)"
                (actionFileClick)="onFileClick(version,$event)"
                (actionLabelClick)="onLabelClick($event)"
                (menuStatusClick)="updateVersionStatus($event,version)"
            ></versions-summary-status-box>
        </li>
        <!-- artworks pagination mini wheel -->
        <li class="loading-more" [hidden]="!loadingMore || resultsStatus[approvalStatusFilter] == SEARCH_STATUS.FINAL">
            <core-helpers-box-loading ></core-helpers-box-loading>
        </li>
    </ul>
    <div class="loader" [hidden]="!(resultsStatus[approvalStatusFilter] == SEARCH_STATUS.LOADING && displayedItems !=null && displayedItems.length == 0) && displayedItems !=null">
        <div class="dimmed dimmed_list_main">
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
        </div>
    </div>
    <core-helpers-box-alert-message-icon 
        [hidden]="!(displayedItems !=null && displayedItems.length == 0) || !hasSearch 
            || resultsStatus[approvalStatusFilter] == SEARCH_STATUS.LOADING 
            || resultsStatus[approvalStatusFilter] == SEARCH_STATUS.INITIAL 
            || resultsStatus[approvalStatusFilter] == SEARCH_STATUS.NOT_ACCEPTABLE"
        [text]="'There are no matches for your query. Try removing filters or typing a new query.'"
        [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
    <core-helpers-box-alert-message-icon 
        [hidden]="!(resultsStatus[approvalStatusFilter] == SEARCH_STATUS.FINAL && displayedItems !=null && displayedItems.length == 0 && !hasSearch)"
        [text]="'There are no artworks.'"
        [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
    <core-helpers-box-alert-message-icon *ngIf="hasSearch && resultsStatus[approvalStatusFilter] == SEARCH_STATUS.NOT_ACCEPTABLE"
        [text]="'Your query is quite general. Consider adding more specific filters or typing a longer term for better results.'"
        [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
</div>
